import { render } from "./Auth.vue?vue&type=template&id=3cd6b143"
import script from "./Auth.vue?vue&type=script&lang=js"
export * from "./Auth.vue?vue&type=script&lang=js"

import "./Auth.vue?vue&type=style&index=0&id=3cd6b143&lang=css"

import exportComponent from "/codebuild/output/src396721354/src/serverlesspressoV3/frontends/vue-display-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__